<template>
  <v-container v-if="product"
               fluid>
    <div class="d-flex justify-space-between align-center">
      <h1>
        Product: {{ product.name }}

        <v-chip v-if="product.is_active"
                color="success"
                label>
          Active
        </v-chip>
        <v-chip v-else
                color="warning"
                label>
          Inactive
        </v-chip>
      </h1>
      <v-btn v-if="product.is_editable"
             :to="{name: 'admin.product.edit', params: {productID: product.id}}"
             color="primary">
        Edit
      </v-btn>
    </div>
    <v-alert v-if="product.is_external"
             type="info"
             tile
             dense
             class="mb-0">
      This product cannot be edited because it is synchronized from an external system.
    </v-alert>
    <v-card class="mb-4">
      <v-card-title>
        {{ product.presentations.length }} Associated {{ product.presentations.length | pluralize('Presentation', false) }}
        <v-spacer></v-spacer>
        <v-text-field v-model="search"
                      append-icon="fal fa-search"
                      label="Search"
                      single-line
                      hide-details
                      @keydown.enter.prevent="">
        </v-text-field>
      </v-card-title>
      <v-data-table :headers="headers"
                    :items="product.presentations"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    :search="search"
                    dense>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import productService from '../../services/productService';

export default {
  data() {
    return {
      busy: false,
      form: new Form({
        name: null,
        status: 'Active',
        external_id: null,
        presentations: [],
      }),
      product: null,
      search: null,
    }
  },
  computed: {
    productID() {
      if (this.$route.params.productID) {
        return parseInt(this.$route.params.productID);
      }
      return null;
    },
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Asset ID',
          value: 'external_id',
        },
        {
          text: 'Type',
          value: 'presentation_type',
        },
        {
          text: 'Status',
          value: 'status',
        }
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      productService.getProduct(this.productID)
        .then(data => {
          this.product = data;
          this.form.name = data.name;
          this.form.status = data.status;
          this.form.presentations = data.presentations;
        })
        .catch(() => {
          this.$toast.error('Product not found.');
          this.$router.replace({name: 'admin.products'});
        })
        .finally(() => {
          this.busy = false;
        })
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      const form = this.form.data();
      form.presentations = form.presentations.map(p => p.id)
      this.form.put(`/api/products/${this.product.id}`, {data: form})
        .then(() => {
          this.$toast.success('Product created.');
          this.$router.push({name: 'admin.products'});
        })
        .catch(err => {

        })
    },
  }
}
</script>
